import { Button, Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import { useHistory } from "react-router-dom";
import { Help } from '../components/atoms/Help';
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { AuthShell } from '../components/molecules/auth-shell/AuthShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';

const useStyles = makeStyles((theme) => ({
    ppoInput: {
        "& label": {
            color: theme.palette.primary.main,
        },

    }

}));

type LoginState = {
    state: number,
    erpId: string,
    error: string,
    contactNo: string,
    otpReference: string,
    otp: string
}


interface SignInPageProps {
}

export const SignInPage = observer<SignInPageProps>(() => {
    const classes = useStyles();
    const store = useStore()
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    return (
        <AuthShell>
            <Formik
                initialValues={{
                    state: 0, // 0 -> OTP Not Yet Send, 1 -> OTP Send but not yet provided by user
                    error: "",
                    erpId: "",
                    contactNo: "",
                    otpReference: "",
                    otp: "",
                }}
                validate={(values) => {
                    const errors: Partial<LoginState> & { general?: string } = {}
                    if (!values.erpId || !values.erpId.match(/^\d{8}$|^[\d\/]{11}$/)) { //TODO Rectify Regex for legecy PPO
                        errors.erpId = 'Valid PPO Number Required (বৈধ পিপিও নম্বর প্রয়োজনীয়)'
                    }
                    if (values.state > 0 && !values.otp && !values.otp.match(/^\d{6}$/)) {
                        errors.otp = 'OTP Required (ওটিপি প্রয়োজনীয়)'
                    }
                    return errors
                }}
                onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                    setSubmitting(true);
                    setFieldValue('error', '')
                    try {
                        if (values.state === 0) {
                            // Send OTP
                            await axios.get<ApiResponse<{ otpReference: string, mobileNumber: string }>>(`/api/auth/request-login-otp/${values.erpId}`)
                                .then(
                                    ({ data: resp }) => {
                                        if (resp.status === "success") {
                                            setFieldValue('contactNo', resp.data.mobileNumber)
                                            setFieldValue('otpReference', resp.data.otpReference)
                                            setFieldValue('state', 1)
                                        } else {
                                            setFieldValue('error', resp.message || 'Error Occured')
                                            enqueueSnackbar(resp.message || 'Error Occured', { variant: 'error' })
                                        }
                                    },
                                    () => { setFieldValue('error', 'Network Error'); enqueueSnackbar('Network Error', { variant: 'error' }) }
                                )
                        } else {
                            // Verify OTP
                            await axios.post<ApiResponse<{ username: string, name: string, jwt: string, refreshToken: string }>>
                                ('/api/auth/login', { username: values.erpId, otp_reference: values.otpReference, otp: values.otp })
                                .then(
                                    ({ data: resp }) => {
                                        if (resp.status === "success") {
                                            store.auth.login({ id: resp.data.username, name: resp.data.name }, resp.data.jwt, resp.data.refreshToken)
                                            history.push('/')
                                        }
                                        else {
                                            setFieldValue('error', resp.message || 'Error Occured')
                                            enqueueSnackbar(resp.message || 'Error Occured', { variant: 'error' })
                                        }
                                    },
                                    () => { setFieldValue('error', 'Network Error'); enqueueSnackbar('Network Error', { variant: 'error' }) }
                                )
                        }
                    } catch (err) {
                        setFieldError('general', err.message)
                    }
                    finally {
                        setSubmitting(false);
                    }
                }}
            >{({ values, isSubmitting, isValid, setFieldValue, setValues }: FormikProps<LoginState>) => {
                return (
                    <Form style={{ backgroundColor: "#e0f4ff" }}>
                        <Grid
                            container
                            direction="column"
                            justify="space-around"
                            alignItems="stretch"
                            spacing={2}

                        >
                            <Grid item>
                                <Typography variant="h6" color="primary">Login (প্রবেশ করুন)</Typography>
                            </Grid>
                            {
                                values.error &&
                                <Grid item>
                                    <Alert severity="error">
                                        <AlertTitle>
                                            Error (ত্রুটি)
                                        </AlertTitle>
                                        {values.error}
                                    </Alert>
                                </Grid>
                            }
                            <Grid item>
                                <Help heading="PPO Number (পিপিও নম্বর)" body={<div style={{ textAlign: "justify" }}>Enter PPO number starting with 8. (8 দিয়ে শুরু হওয়া PPO নম্বর লিখুন।)<br />
                                    By logging in the application, you agree to our <a href="https://mapp.wbsedcl.in/sahayogi/newapp-100-20241028/sahayogi-privacy-policy.html" rel="noopener noreferrer" target="_blank"> Terms of Use & Privacy Policy</a>.
                                    (এই অ্যাপ্লিকেশনটি ব্যবহার করার মাধ্যমে আপনি আমাদের <a href="https://mapp.wbsedcl.in/sahayogi/newapp-100-20241028/sahayogi-privacy-policy.html" rel="noopener noreferrer" target="_blank">ব্যবহারের শর্তাবলী এবং গোপনীয়তা নীতির </a>প্রতি সম্মতি জানাচ্ছেন।)

                                </div>}>

                                    <AppInput
                                        inputProps={{ maxLength: 17 }}
                                        fullWidth={true}
                                        label="PPO Number (পিপিও নম্বর)"
                                        name="erpId"
                                        type="text"
                                        disabled={values.state > 0 || isSubmitting}
                                        className={classes.ppoInput}
                                    />
                                </Help>
                            </Grid>
                            {
                                values.state === 0 &&
                                <Grid item container justify="space-between">
                                    <Grid item>
                                        <LoadingButton
                                            type="submit"
                                            color="primary"
                                            variant="contained"
                                            size="large"
                                            loading={isSubmitting}
                                        >Request OTP (ওটিপি প্রেরণ করুন)</LoadingButton>
                                    </Grid>
                                </Grid>
                            }
                            {
                                values.state === 1 &&
                                <>
                                    <Grid item>
                                        <Typography variant="body2" color="primary">OTP has been sent to following Mobile Number (নিম্নলিখিত মোবাইল নম্বরটিতে ওটিপি পাঠানো হয়েছে): <strong>{values.contactNo}</strong></Typography>
                                        {/* <Typography variant="h6" color="initial">নিম্নলিখিত মোবাইল নম্বরটিতে ওটিপি পাঠানো হয়েছে</Typography> */}
                                        {/* <Typography variant="h6" color="initial"><strong>{values.contactNo}</strong></Typography> */}
                                    </Grid>
                                    <Grid item>
                                        <AppInput
                                            inputProps={{ maxLength: 6 }}
                                            fullWidth={true}
                                            label="OTP (ওটিপি)"
                                            name="otp"
                                            type="text"
                                            disabled={isSubmitting}
                                            className={classes.ppoInput}
                                        />
                                    </Grid>
                                    <Grid item container justify="space-between">
                                        <Grid item>
                                            <Button type="reset" color="primary" disabled={isSubmitting}>Reset (রিসেট)</Button>
                                        </Grid>
                                        <Grid item>
                                            <LoadingButton
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                size="large"
                                                loading={isSubmitting}
                                            >Login (প্রবেশ করুন)</LoadingButton>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            <Divider style={{ margin: "20px" }} />
                            <Grid item container justify="space-between" spacing={3}>
                                {/* <Grid item>
                                    <Button variant="outlined" color="primary" onClick={() => history.push('/update-mobile')} disabled={isSubmitting}>Update Mobile No (মোবাইল নম্বর আপডেট করুন)</Button>
                                </Grid> */}
                                <Grid item>
                                    <Button variant="outlined" color="primary" type="button" onClick={() => history.push('/know-appl-status')} disabled={isSubmitting}>Know Application Status (আবেদনের স্থিতি জানুন)</Button>
                                </Grid>
                            </Grid>
                            <Divider style={{ margin: "20px" }} />
                        </Grid>
                        {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    </Form>
                )
            }}
            </Formik>
        </AuthShell >
    )
})